import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ToastProvider, UiRoot } from './components/ui';
import '@fontsource-variable/plus-jakarta-sans';
import '@fontsource/montserrat/latin-700.css';
import '@fontsource/montserrat/latin-800.css';
import '@fontsource/space-grotesk/latin-700.css';
import '@fontsource-variable/geist';
import '@fontsource-variable/jetbrains-mono';
import './tailwind.css';
import { applyTheme } from './theme';

applyTheme();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <UiRoot>
        <ToastProvider>
          <App />
        </ToastProvider>
      </UiRoot>
    </BrowserRouter>
  </StrictMode>,
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => { void navigator.serviceWorker.register('/sw.js'); });
}
